module.exports = __webpack_public_path__ + "static/media/suggestion-CreativeCenter-tablet.f0967429.png";